<template>
  <div>
    <v-dialog v-model="open" max-width="600px" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="info" v-bind="attrs" v-on="on" small>
          <v-icon left>mdi-group</v-icon>
          Agrupar
        </v-btn>
      </template>

      <v-card>
        <v-toolbar elevation="0">
          <v-card-title class="pl-0">
            {{ title }}
          </v-card-title>

          <v-spacer />

          <v-btn icon @click="open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4 py-0">
          <v-form ref="form" v-model="formValid" lazy-validation class="pa-0 ma-0">
            <v-row class="ma-2">
              <v-col cols="12" md="8" sm="12" class="pa-0">
                <v-select dense v-model="formData.account" :error="accountError" :items="accounts.data"
                  :loading="loadingAccounts" item-text="account_name" item-value="name" menu-props="auto" label="Conta"
                  single-line outlined :rules="rulesAccount" color="primary"></v-select>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="pa-0">
                <v-autocomplete chips autocomplete="off" multiple v-model="formData.keywords_from"
                  :search-input.sync="searchKeywordFrom" :loading="loadingKeywordsFrom" :items="keywordsFrom.data"
                  item-text="name" item-value="id" menu-props="auto" label="De" outlined clearable required
                  :rules="rulesFrom"></v-autocomplete>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="pa-0">
                <v-autocomplete autocomplete="off" v-model="formData.keyword_to" :search-input.sync="searchKeywordTo"
                  :loading="loadingKeywordsTo" :items="keywordsTo.data" item-text="name" item-value="id" menu-props="auto"
                  label="Para" single-line outlined dense clearable required :rules="rulesTo"></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="close">
            Cancelar
          </v-btn>
          <confirm-modal :loading="loading" text action-color="primary" action-text="Agrupar" :action="save"
            title="Tem certeza?"
            description="Deseja confirmar o agrupamento das tags? Todas avaliações que possuírem essas tags serão atualizadas" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { handleResponseError } from '@/api/handleError'
import { mapState } from 'vuex'
import ConfirmModal from '@/components/ConfirmModal'

export default {
  name: 'KeywordGroupModal',
  props: {
    actionType: String,
    title: {
      type: String,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
    }
  },
  computed: {
    ...mapState({
      accounts: state => state.accounts.all,
      keywordsFrom: state => state.keywords.allFromGroup,
      keywordsTo: state => state.keywords.allToGroup,
    }),
  },
  components: {
    ConfirmModal,
  },
  methods: {
    resetData: function () {
      this.formData.keyword_to = null
      this.formData.keywords_from = []
      this.formData.account = null
    },
    close: function () {
      this.resetData()
      this.open = false
    },
    validate: function () {
      return this.$refs.form.validate()
    },
    save: async function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        await this.$store.dispatch('keywords/group', this.formData).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao criar tag.')
          this.showNotification(message, 'red darken-2')
          this.loading = false
        })
        this.resetData()
        this.loading = false
        this.onSave()
        this.open = false
      }
    },
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    fetchAccounts: async function () {
      this.loadingAccounts = true
      this.accountError = false
      await this.$store.dispatch('accounts/getAccounts', { limit: 0 }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as contas.')
        this.showNotification(message, 'red darken-2')
        this.loadingAccounts = false
        this.accountError = true
      })
      this.loadingAccounts = false
      this.accountError = false
    },
    fetchKeywordsFrom: async function () {
      if (!this.formData.account) return
      this.loadingKeywordsFrom = true
      await this.$store.dispatch('keywords/getKeywordsFromGroup', {
        account: this.formData.account,
        search: this.searchKeywordFrom,
        limit: 100,
        page: 1,
        order: 'asc',
        sort: 'name',
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as tags.')
        this.showNotification(message, 'red darken-2')
        this.loadingKeywordsFrom = false
      })
      this.loadingKeywordsFrom = false
    },
    fetchKeywordsTo: async function () {
      if (!this.formData.account) return
      this.loadingKeywordsTo = true
      await this.$store.dispatch('keywords/getKeywordsToGroup', {
        account: this.formData.account,
        search: this.searchKeywordTo,
        limit: 100,
        page: 1,
        order: 'asc',
        sort: 'name',
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as tags.')
        this.showNotification(message, 'red darken-2')
        this.loadingKeywordsTo = false
      })
      this.loadingKeywordsTo = false
    },
  },
  mounted() {
    this.fetchAccounts()
  },
  data: () => ({
    open: false,
    timeoutKeywordsFrom: null,
    timeoutKeywordsTo: null,
    loadingKeywordsTo: false,
    loadingKeywordsFrom: false,
    loadingAccounts: false,
    loading: false,
    searchKeywordTo: '',
    searchKeywordFrom: '',
    accountError: false,
    formValid: false,
    loadingDelete: false,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    formData: {
      keyword_to: null,
      keywords_from: [],
      account: null
    },
    rulesFrom: [
      v => !!v || 'Escolha as tags que devem ser agrupadas',
    ],
    rulesTo: [
      v => !!v || 'Escolha a tags que deve ficar'
    ],
    rulesAccount: [
      v => !!v || 'A conta é obrigatória',
    ],
  }),
  watch: {
    'formData.keywordFrom': function (keywordFrom) {
      this.formData.keywordFrom = keywordFrom
    },
    'formData.keyword_to': function (keywordTo) {
      this.formData.keyword_to = keywordTo
    },
    'formData.account': function (account) {
      this.formData.account = account
      this.formData.keywords_from = []
      this.formData.keyword_to = null
      this.fetchKeywordsFrom()
      this.fetchKeywordsTo()
    },
    searchKeywordTo: function () {
      clearTimeout(this.timeoutKeywordsTo)
      this.timeoutKeywordsTo = setTimeout(this.fetchKeywordsTo, 300)
    },
    searchKeywordFrom: function () {
      clearTimeout(this.timeoutKeywordsFrom)
      this.timeoutKeywordsFrom = setTimeout(this.fetchKeywordsFrom, 300)
    },
  }
}
</script>

<style scoped></style>